import React, { useCallback, useState } from "react";
import Sidebar from "../profile/Sidebar";

import Navbars from "../Navbars";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect } from "react";
const ViewPost = () => {
    const postingData = useSelector((state) => state.getPosting.data);
    const routeParams = useParams();
    const [previewData, setPreviewData] = useState({});
    useEffect(() => {
        let data=postingData.filter((val)=>{
            if(val.id==routeParams.id)
            return val
        })
        setPreviewData(data[0])
        console.log("data",data)
      }, [postingData]);
    
  return (
    <div className="conatiner-fluid" style={{ backgroundColor: "#F5F5F5" }}>
      <Navbars />
      <div className="d-flex gap-5 pe-3 main_div">
        <Sidebar />
        <div
          className="inner2_div ps-3 pe-3 pb-5 mb-5"
          style={{
            boxShadow: "none",
            border: "1px solid rgba(188, 188, 188, 0.3)",
            borderRadius: "10px",
            marginTop: "85px",
          }}
        >
          <div className="post-card d-flex jusitfy-content-center align-items-center flex-column">
          <div className="d-flex gap-2 align-items-center  preview_maindiv">
         
         <p className="preview_heading">Posting Detail’s View</p>
       </div>
            <div className="d-flex w-100 my-2 flex-sm-column flex-md-row">
              <div className="w-md-50 w-100 d-flex flex-column my-2 px-3">
                <label className="signin-label">Name</label>
                <input
                  className={` add_search business_search upper_input px-0`}
                  type="name"
                  value={previewData.title}
                  placeholder="Enter Name"
                //   {...register("name")}
                ></input>
                
              </div>
              <div className="w-md-50 w-100 d-flex flex-column my-2 px-3">
                <label className="signin-label">Email</label>
                <input
                  className={` add_search business_search upper_input px-0`}
                  placeholder="Enter email"
                  type="email"
                  value={previewData.email}
                //   {...register("email")}
                ></input>
               
              </div>
            </div>
            <div className="d-flex w-100 my-2 flex-sm-column flex-md-row">
              <div className="w-md-50 w-100 d-flex flex-column my-2 px-3">
                <label className="signin-label">Description</label>
                <textarea
                  className={` add_search business_search upper_input px-0`}
                  type="description"
                  value={previewData.description}
                  placeholder="Enter description"
                //   {...register("description")}
                ></textarea>
               
              </div>
              <div className="w-md-50 w-100 d-flex flex-column my-2 px-3">
                <label className="signin-label">Phone</label>
                <input
                  className={` add_search business_search upper_input px-0`}
                  type="phone"
                  placeholder="Enter phone number"
                  value={previewData.number}
                //   {...register("phone")}
                ></input>

              </div>
            </div>
            <div className="d-flex w-100 my-2 flex-sm-column flex-md-row">
              <div className="w-md-50 w-100 d-flex flex-column my-2 px-3">
                <label className="signin-label">location</label>
                <input
                  className={` add_search business_search upper_input px-0`}
                  type="location"
                  placeholder="Enter location"
                  value={previewData.address}
                //   {...register("location")}
                ></input>
              
              </div>
              <div className="w-md-50 w-100 d-flex flex-column my-2 px-3">
                <label className="signin-label">Price</label>
                <input
                  className={` add_search business_search upper_input px-0`}
                  type="price"
                  placeholder="Enter price"
                  value={previewData.price}
                //   {...register("price")}
                ></input>
             
              </div>
            </div>
            <div className="d-flex w-100 my-2 flex-sm-column flex-md-row">
              <div className="w-md-50 w-100 d-flex flex-column my-2 px-3">
                <label className="signin-label">City</label>
                <input
                  className={` add_search business_search upper_input px-0`}
                  type="city"
                  value={previewData.city}
                  placeholder="Enter city"
                //   {...register("city")}
                ></input>
           
              </div>
              <div className="w-md-50 w-100 d-flex flex-column my-2 px-3">
                <label className="signin-label">State</label>
                <input
                  className={` add_search business_search upper_input px-0`}
                  type="state"
                  value={previewData.state}
                  placeholder="Enter state"
                //   {...register("state")}
                ></input>
          
              </div>
            </div>
            <div className="d-flex w-100 my-2 flex-sm-column flex-md-row">
              <div className="w-md-50 w-100 my-2 px-3">
                <label htmlFor="image_upload">Logo</label>
                <div className=" align-items-center">
                  <div className="custom-file">
                  
                 
                  </div>
                </div>
              </div>
              <div className="w-md-50 w-100 my-2 px-3">
                <label>Images</label>

             

                
              </div>
            </div>
            <div className="d-flex w-100 my-2 flex-sm-column flex-md-row">
              <div className="w-md-50 w-100 d-flex flex-column my-2 px-3">
                <label className="signin-label">zip code</label>
                <input
                  className={` add_search business_search upper_input px-0`}
                  type="zipCode"
                  value={previewData.zipcode}
                  placeholder="Enter zipcode"
                //   {...register("zipCode")}
                ></input>
              
              </div>
              <div className="d-flex w-md-50 w-100 flex-sm-column flex-md-row px-3 my-2 gap-3">
                <div className="w-md-25 w-100 d-flex flex-column  ">
                  <label className="signin-label">{previewData.is_sell==true?"Starting date":"Post Published"}</label>
                  <input
                    id="text"
                    class="form-control"
                    type="text"
                    value={previewData.schedule_time_start}
                    // {...register("S_date")}
                  />
                
                </div>
                {previewData.is_sell==true?<div className="w-md-25 w-100 d-flex flex-column ">
                  <label className="signin-label">Ending date</label>
                  <input
                    id="endDate"
                    class="form-control"
                    type="date"
                    value={previewData.schedule_time_end}
                    // {...register("E_date")}
                  />
                
                </div>:null}
                
              </div>
            </div>
            
              
           
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewPost;
